"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/CreateNew/NewChat/parts.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);

var _icons = require('../Compose/icons');

/* Pieces New chat's steps share: the 64px header (close or back, centred
 * title, one action) and the error line. */













 const Header = ({ left, onLeft, title, subtitle, action, isActionEnabled, isActionBusy, onAction }) => {
  const isOn = !!isActionEnabled && !isActionBusy
  return (
    _react2.default.createElement('div', { className: "new-chat--header", __self: this, __source: {fileName: _jsxFileName, lineNumber: 25}}
      , _react2.default.createElement('button', { type: "button", className: "new-chat--icon-btn", 'aria-label': left === 'back' ? 'Back' : 'Close', onClick: onLeft, __self: this, __source: {fileName: _jsxFileName, lineNumber: 26}}
        ,  left === 'back' ? _react2.default.createElement(_icons.ChevronLeftIcon, { size: 20, __self: this, __source: {fileName: _jsxFileName, lineNumber: 27}} ) : _react2.default.createElement(_icons.CloseIcon, { size: 20, __self: this, __source: {fileName: _jsxFileName, lineNumber: 27}} ) 
      )
      , _react2.default.createElement('h3', { className: "new-chat--title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 29}}
        ,  title 
        ,  subtitle && _react2.default.createElement('small', { className: "new-chat--subtitle", __self: this, __source: {fileName: _jsxFileName, lineNumber: 31}},  subtitle ) 
      )
      ,  action
        ? (
            _react2.default.createElement('button', {
              type: "button",
              className: _classBuilder2.default.call(void 0, 'new-chat--action', !isOn && 'new-chat--action---off'),
              disabled: !isOn,
              'aria-busy': isActionBusy || undefined,
              onClick: onAction, __self: this, __source: {fileName: _jsxFileName, lineNumber: 35}}

              ,  action 
            )
          )
        : _react2.default.createElement('span', { className: "new-chat--header-space", 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 45}} ) 
    )
  )
}; exports.Header = Header

 const ErrorLine = ({ message }) => (message
  ? (
      _react2.default.createElement('div', { className: "new-chat--error", role: "alert", __self: this, __source: {fileName: _jsxFileName, lineNumber: 52}}
        , _react2.default.createElement(_icons.AlertIcon, { size: 16, __self: this, __source: {fileName: _jsxFileName, lineNumber: 53}} )
        , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 54}},  message )
      )
    )
  : null); exports.ErrorLine = ErrorLine
